// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".free-text.showingTextualFeedback[data-v-8171c6f8] .interactive-content{display:none}.free-text[data-v-8171c6f8] .interactive-content{padding:0 1rem!important}", ""]);
// Exports
module.exports = exports;
